import { render, staticRenderFns } from "./TotalsDisplay.vue?vue&type=template&id=5aec1e7c"
import script from "./TotalsDisplay.vue?vue&type=script&lang=js"
export * from "./TotalsDisplay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports